module.exports = __webpack_public_path__ + "static/media/ig.8bf936a9.svg";